import React from "react";
import { StepProps } from "../../types";
import { useWebTranslation } from "translations";
import ChatMessage, { ChatContainer } from "ui-kit/ChatMessage/ChatMessage";
import Colors from "ui-kit/colors";
import { Typography } from "ui-kit/Typography";
import Gutter from "ui-kit/Gutter";
import municipalities, { Municipality } from "data/municipalities";
import { renderIf } from "utils/utils";
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
import { formatErrorMessage } from "utils/validation";
import FlowButtons from "components/Signup/components/FlowButtons/FlowButtons";
import { useSignupDispatch } from "components/Signup/store/hooks";
import { updateCustomer } from "components/Signup/store/slices/customer";
import { useCustomer } from "components/Signup/store/selectors/customer";
import { useError } from "components/Signup/store/selectors/metadata";
import { SelectorSearch } from "components/Signup/components/SelectorSearch";

const UserInfo = ({ next, isValid, previous, transitioning }: StepProps) => {
  const { t } = useWebTranslation();

  const dispatch = useSignupDispatch();
  const { region, address } = useCustomer();
  const error = useError();

  return (
    <ChatContainer leaving={transitioning}>
      <style jsx>{`
        /* Not very pretty but just testing the concept */
        input:focus:invalid {
          border: 1px solid ${Colors.orange300};
          border-radius: 8px;
        }
      `}</style>
      <ChatMessage>
        <Typography>{t("signup.user_info.municipality.text_1")}</Typography>
      </ChatMessage>
      <Gutter size={2} />
      <ChatMessage fromMe small>
        <SelectorSearch<Municipality>
          onSelectedItemChange={({ selectedItem }) => {
            dispatch(
              updateCustomer({
                region: selectedItem?.id,
                address: { ...address!, city: selectedItem?.name ?? "" },
              })
            );
          }}
          placeholder={t("signup.user_info.municipality.placeholder")}
          items={municipalities}
          defaultSelectedItem={
            municipalities.find((item) => item.id === region) ?? null
          }
          itemToString={(item) => item?.name ?? ""}
        />
      </ChatMessage>
      {renderIf(
        !!error,
        <ErrorMessage>
          <Typography color="error">{formatErrorMessage(error)}</Typography>
        </ErrorMessage>
      )}
      <FlowButtons
        inProgress={transitioning}
        next={next}
        disabled={!isValid}
        previous={previous}
        backButton={false}
      />
    </ChatContainer>
  );
};

export default UserInfo;
